@if (isDebugMode()) {
  @for (code of issueCodes(); track code) {
    <span class="hitl-ask-context__chip">{{ code }}</span>
  }
  @if (askedCount() > 0) {
    <span class="hitl-ask-context__count mat-font-label-sm mat-text-on-surface-variant">
      Asked {{ askedCount() }} {{ askedCount() === 1 ? "time" : "times" }} previously
    </span>
  }
}